import React from 'react';
import { Typography, Divider, Button } from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import { isMobile } from 'react-device-detect';

const PaymentSummary = ({
  // Data props
  selectedReceipts,
  currency,
  policyData,
  
  // State props
  checked,
  expandedPolicies,
  loadingPayment,
  isProcessingPayment,
  
  // Function props
  calculateTotalSum,
  handleToggle,
  toggleExpand,
  handlePaymentRequest,
  
  // Component props
  Spinner,
  
  // Style props
  classes
}) => {
  const hasUSD = selectedReceipts.every(item => item.currency === 'USD');

  return (
    <div
      style={{
        width: isMobile ? '100%' : '264px',
        minHeight: isMobile ? 'auto' : '416px',
        background: '#2D6DF6',
        borderRadius: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '14px 18px 20px',
        height: isMobile ? 'auto' : '100%',
        marginTop: isMobile ? '20px' : '0'
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
        }}
      >
        {/* Total Amount Display */}
        <Typography style={{ color: '#FFFFFF', fontSize: '22px', fontFamily: 'Sura Sans' }}>
          {`$${calculateTotalSum()}`}
        </Typography>
        <Divider className={classes.amountDivider} />
        <Typography style={{ color: '#FFFFFF', fontSize: '12px', fontFamily: 'Sura Sans' }}>
          TOTAL A PAGAR {!hasUSD || selectedReceipts.length === 0 || (hasUSD && checked) ? 'MXN' : 'USD'}
        </Typography>

        {/* Currency Toggle */}
        {hasUSD && selectedReceipts.length > 0 && (
          <div
            style={{
              display: 'flex',
              height: '53px',
              width: '100%',
              background: '#0033A0',
              borderRadius: '10px',
              padding: '7px 20px 7px 17px',
              alignItems: 'center',
              margin: '15px 0',
              justifyContent: 'space-between'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography style={{ color: '#FFFFFF', fontSize: '14px', fontFamily: 'Sura Sans' }}>
                Tipo de cambio: {currency}
              </Typography>
            </div>
            <div
              onClick={handleToggle}
              style={{
                width: '62px',
                height: '24px',
                borderRadius: '12px',
                backgroundColor: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: checked ? 'flex-end' : 'flex-start',
                padding: '5px',
                cursor: 'pointer',
                border: '1px solid #2D6DF6',
                position: 'relative'
              }}
            >
              <div
                style={{
                  width: '20px',
                  height: '20px',
                  borderRadius: '15px',
                  backgroundColor: '#2D6DF6',
                  position: 'absolute',
                  left: checked ? '38px' : '2px',
                  transition: 'left 0.3s'
                }}
              />
              <span
                style={{
                  color: '#2D6DF6',
                  fontSize: '14px',
                  position: 'absolute',
                  left: checked ? '5px' : '25px',
                  transition: 'left 0.3s'
                }}
              >
                {!hasUSD || (hasUSD && checked) ? 'MXN' : 'USD'}
              </span>
            </div>
          </div>
        )}

        {/* Policy Summary Cards */}
        {Object.keys(policyData).map(policyId => (
          <div
            key={policyId}
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              borderRadius: '12px',
              padding: '10px',
              marginTop: '10px',
              border: '1px solid #81B1FF'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#FFFFFF' }}>
                Póliza: {policyId}
              </Typography>
              <div
                onClick={() => toggleExpand(policyId)}
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {expandedPolicies[policyId] ? (
                  <ExpandLess style={{ color: '#FFFFFF' }} />
                ) : (
                  <ExpandMore style={{ color: '#FFFFFF' }} />
                )}
              </div>
            </div>
            <Typography style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#FFFFFF', marginBottom: '10px' }}>
              {policyData[policyId].solution}
            </Typography>
            {expandedPolicies[policyId] &&
              policyData[policyId].receipts.map((receipt, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    margin: '5px 0'
                  }}
                >
                  <Typography
                    style={{ fontSize: '11px', fontWeight: '400', fontFamily: 'Sura Sans', color: '#FFFFFF' }}
                  >
                    Recibo: {receipt.invoice}
                  </Typography>
                  <Typography style={{ fontSize: '13px', fontFamily: 'Sura Sans', color: '#FFFFFF' }}>
                    {`$${parseFloat(receipt.total || 0)
                      .toFixed(2)
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                  </Typography>
                </div>
              ))}
          </div>
        ))}
      </div>
      
      {/* Payment Button */}
      <Button
        onClick={handlePaymentRequest}
        disabled={selectedReceipts.length === 0 || loadingPayment || isProcessingPayment}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '40px',
          marginTop: '10px',
          background: selectedReceipts.length > 0 && !loadingPayment && !isProcessingPayment ? '#E3E828' : '#CCCCCC',
          borderRadius: '28px',
          cursor: selectedReceipts.length > 0 && !loadingPayment && !isProcessingPayment ? 'pointer' : 'not-allowed',
          pointerEvents: selectedReceipts.length > 0 && !loadingPayment && !isProcessingPayment ? 'auto' : 'none',
          color: '#212529',
          fontFamily: 'Sura Sans',
          fontSize: '13px',
          textTransform: 'none'
        }}
      >
        {(loadingPayment || isProcessingPayment) ? <Spinner /> : 'Pagar'}
      </Button>
    </div>
  );
};

export default PaymentSummary;



// WEBPACK FOOTER //
// ./src/containers/client/receipts/PaymentSummary.js